import React, { createContext } from 'react';

export const ViewSettingsContext = createContext();

const ViewSettingsProvider = (props) => {
  return (
    <ViewSettingsContext.Provider value={{ ...props }}>
      {props.children}
    </ViewSettingsContext.Provider>
  )
}

export default ViewSettingsProvider
